import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { FileDown, Loader2 } from 'lucide-react';
import { Button } from './ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function lastMonths(n = 12) {
  const out = [];
  const d = new Date();
  d.setDate(1);
  for (let i = 0; i < n; i++) {
    out.push({
      value: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`,
      label: d.toLocaleString('en-GB', { month: 'long', year: 'numeric' }),
    });
    d.setMonth(d.getMonth() - 1);
  }
  return out;
}

// Month picker + "Download App Activity PDF" — reused on the employee profile
// page and inside the App Activity detail sheet.
export const AppActivityPdfButton = ({ userId, userName }) => {
  const months = lastMonths();
  const [month, setMonth] = useState(months[0].value);
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      const params = month === 'all' ? {} : { month };
      const res = await axios.get(`${API}/admin/app-login-activity/${userId}/export-pdf`, {
        params, responseType: 'blob',
      });
      const url = window.URL.createObjectURL(res.data);
      const a = document.createElement('a');
      const safe = (userName || 'staff').replace(/[^a-zA-Z0-9 _-]/g, '').replace(/ /g, '_');
      a.href = url;
      a.download = `${safe}_app_activity${month === 'all' ? '' : `_${month}`}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
      toast.success('App Activity PDF downloaded');
    } catch {
      toast.error('Failed to download the PDF');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex items-center gap-2" data-testid="app-activity-pdf-controls">
      <select
        value={month}
        onChange={(e) => setMonth(e.target.value)}
        className="h-8 bg-background border border-border rounded-sm px-2 text-xs"
        data-testid="app-activity-pdf-month"
      >
        {months.map((m) => <option key={m.value} value={m.value}>{m.label}</option>)}
        <option value="all">Full history</option>
      </select>
      <Button
        size="sm"
        onClick={download}
        disabled={busy}
        className="h-8 rounded-sm text-[11px] uppercase tracking-wider bg-primary text-primary-foreground hover:bg-yellow-300"
        data-testid="app-activity-pdf-download-btn"
      >
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <FileDown className="w-3.5 h-3.5 mr-1" />}
        App Activity PDF
      </Button>
    </div>
  );
};
